<template>
  <div>
    <el-dialog
      top="10vh"
      width="320px"
      center
      :title="`「${
        TransferUserBankAccountObj.id ? TransferUserBankAccountObj.id : ''
      }」银行账户转移`"
      :visible="TransferUserBankAccountObj.visible"
      @close="HandleCancel"
    >
      <el-row>
        <el-form :inline="true">
          <el-form-item label="要转移的目标：">
            <el-input
              style="width: 120px"
              placeholder="卡主用户名"
              v-model="toUsername"
              size="mini"
              clearable
            />
          </el-form-item>
        </el-form>
      </el-row>

      <el-alert type="info" :closable="false"
        >转移完成后，需再至银行卡管理的接单设置重新选择所要的金额区间</el-alert
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="transferUserBankAccount()" type="success">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { transferUserAccount } from "@/api/account";
export default {
  mixins: [mainCommon],
  props: ["TransferUserBankAccountObj"],
  data() {
    return {
      toUsername: null,
    };
  },
  created() {},
  methods: {
    transferUserBankAccount() {
      transferUserAccount({
        accId: this.TransferUserBankAccountObj.id,
        toUsername: this.toUsername,
      })
        .then((res) => {
          this.$notify.success(res.message);
          this.$emit("HandleGetList");
          this.HandleCancel();
        })
        .catch(() => {})
        .finally(() => {});
    },
    HandleCancel() {
      this.toUsername = null;
      this.$emit("update:transfer-user-bank-account-obj", { visible: false });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/account/bank/TransferUserBankAccountDialog.vue